import {
  ContactCTA,
  HomeHero,
  KitchenExploreCTA,
  KitchenVisualizerCTA,
  MoodboardsCTA,
  NewsWidget,
  PartnerTicker,
  QuickLinks,
  Stats,
  useProfile,
} from "@prmf/site-components";
import { routes } from "@prmf/site-router";
import { Link } from "@remix-run/react";

function Intro(props: { sector?: string }) {
  const dict = {
    private: {
      intro:
        "We have over 70 years experience of supplying contract kitchens to the UK’s leading private property developers. Our service levels and customer care are unrivalled in the industry, making Paula Rosa Manhattan the perfect partner for your kitchen project.",
      link: routes.privateDevelopers,
    },
    social: {
      intro:
        "Paula Rosa Manhattan is committed to manufacturing and supplying contract kitchens for the social housing sector which includes affordable housing kitchens and supported living kitchens. We exceed expectations of registered providers and residents alike and help you to gain credits in BREEAM and the Code for Sustainable Homes’ schemes.",
      link: routes.socialHousing,
    },
    bespoke: {
      intro:
        "We have over 70 years experience of supplying contract kitchens to the UK’s leading private property developers. Our service levels and customer care are unrivalled in the industry, making Paula Rosa Manhattan the perfect partner for your kitchen project.",
      link: routes.bespokeSolutions,
    },
  };
  const f = dict[(props.sector as "private") || "private"];
  return (
    <section className="container max-w-3xl space-y-8 py-10 text-center md:pb-10">
      <h2 className="text-2xl font-bold md:text-3xl">
        A partner you can rely on
      </h2>
      <p className="font-light">{f.intro}</p>
      <Link
        className="mx-auto table rounded-full bg-neutral-400 px-4 py-2 text-sm text-white"
        to={f.link}
      >
        Find out more about PRMF
      </Link>
    </section>
  );
}

function Welcome(props: { name?: string }) {
  return (
    <section className="container space-y-8 pt-10 text-center md:pb-10">
      <h2 className="text-2xl font-bold md:text-3xl">
        Welcome back, {props.name}
      </h2>
      <p className="font-light">
        We’ve saved your moodboards to your home page so you can pick up where
        you left off.
      </p>
      <MoodboardsCTA />
    </section>
  );
}

const Home: React.FC = () => {
  const profile = useProfile();
  return (
    <div>
      <HomeHero />
      <PartnerTicker />
      {profile.auth && profile.moodboards.length ? (
        <Welcome name={profile.name} />
      ) : (
        <Intro sector={profile.sector} />
      )}
      <KitchenExploreCTA />
      <QuickLinks />
      <KitchenVisualizerCTA />
      <Stats
        data={[
          {
            label: "Kitchens manufactured",
            value: "278,976",
            since: "2015",
            linkLabel: "World class manufacturing",
            linkRoute: routes.innovation,
            bgColor: "#FFCC80",
          },
          {
            label: "Green energy used",
            value: "12.7",
            unit: "Gwh",
            since: "2018",
            linkLabel: "Our sustainability journey",
            linkRoute: routes.sustainability,
            bgColor: "#6AE8A4",
          },
          {
            label: "CO2 avoided",
            value: "2611",
            unit: "tonnes",
            since: "2018",
            linkLabel: "Our sustainability journey",
            linkRoute: routes.sustainability,
            bgColor: "#6AE8A4",
          },
          {
            label: "Years in business",
            value: "77",
            since: "1946",
            linkLabel: "Our History",
            linkRoute: routes.history,
            bgColor: "#80EFFF",
          },
        ]}
      />
      <NewsWidget />
      <ContactCTA />
    </div>
  );
};

export default Home;
